const Constants = {
  HH_COMPONENTS_URL: process.env.VUE_APP_HH_COMPONENTS_URL,
  ACCESS_DASHBOARD_URL: process.env.VUE_APP_ACCESS_DASHBOARD,
  COMPONENT_ENV: process.env.VUE_APP_COMPONENT_ENV,
  LANDING_PAGE_URL: process.env.VUE_APP_LANDING_PAGE_URL,
  APP_LIST: [{
      title: "Employee Hub",
      logo: require("@/assets/images/employee_hub_logo.svg"),
      url: process.env.VUE_APP_EMPLOYEE_HUB_HOME,
      description: "The single place for Autodesk workers to find the tools and information they need to be productive"
    },
    {
      title: "Autodesk One",
      logo: require("@/assets/images/autodesk_logo_generic.svg"),
      url: "https://one.autodesk.com",
      description: "Autodesk’s intranet with news and resources for workers"
    },
    {
      title: "Engineer's Home Page",
      logo: require("@/assets/images/ehp_logo.svg"),
      url: "https://engineering.autodesk.com",
      description: "The central connection point for the Autodesk Engineering community"
    },
    {
      title: "Password management",
      logo: require("@/assets/images/manage_password_logo.svg"),
      fn: "openChangePwdModal",
      description: "Change, update, or reset your Autodesk password"
    },

    {
      title: "Two-step verification",
      logo: require("@/assets/images/duo_logo.svg"),
      url: process.env.VUE_APP_TWO_STEP_VERIFICATION,
      description: "Register for the Duo app to access Autodesk applications"
    },
    {
      title: "Facilities request",
      logo: require("@/assets/images/bim360_logo.svg"),
      url: "https://autodesk.ops.bim360ops.com",
      description: "Submit a facilities request using BIM 360 Ops"
    },
    {
      title: "All applications",
      logo: require("@/assets/images/employee_hub_logo.svg"),
      url: process.env.VUE_APP_ACCESS_DASHBOARD,
      description: "One place to serve all your application and access related needs"
    }
  ]
};

export default Constants;